import { Directive, Input, TemplateRef, HostListener, OnInit, ElementRef, ComponentRef, OnDestroy } from '@angular/core';
import {
  OverlayRef,
  Overlay,
  OverlayPositionBuilder,
  ConnectedPosition
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { TooltipComponent } from './tooltip.component';

/* istanbul ignore file */
@Directive({ selector: '[appTooltip]' })
export class TooltipDirective implements OnInit, OnDestroy {
  @Input('appTooltip') content: string | TemplateRef<any>;
  @Input('tooltipPosition') position: 'top' | 'bottom'= 'top';
  @Input('tooltipShow') showTooltip: boolean = true;
  private overlayRef: OverlayRef;

  constructor(
    private readonly overlayPositionBuilder: OverlayPositionBuilder,
    private readonly elementRef: ElementRef<any>,
    private readonly overlay: Overlay
  ) {}

  ngOnInit() {
    let position: ConnectedPosition = this.getPosition(this.position)
    const positionStrategy = this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions([
        position
      ]);

    this.overlayRef = this.overlay.create({ positionStrategy });
  }

  ngOnDestroy() {
    this.hide();
  }

  @HostListener('mouseover')
  public handleMouseover(){
    this.show();
  }

  @HostListener('mouseout')
  public handleMouseLeave() {
    this.hide();
  }

  @HostListener('click')
  public handleClick() {
    this.hide();
  }

  @HostListener('wheel')
  public onMousewheelEvent() {
    this.hide();
  }

  public show() {
    if(this.showTooltip) {
      const tooltipPortal = new ComponentPortal(TooltipComponent);

      const tooltipRef: ComponentRef<TooltipComponent> = this.overlayRef.attach(
        tooltipPortal
      );
  
      if (typeof(this.content) === 'string') {
        tooltipRef.instance.text = this.content;
      } else {
        tooltipRef.instance.content = this.content;
      }
  
      tooltipRef.instance.position = this.position;
    }
  }

  public hide() {
    if(this.showTooltip) {
      this.overlayRef.detach();
    }
  }

  public getPosition(position: string): ConnectedPosition {
    if(position === 'bottom'){
      return {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top',
        offsetY: 8
      }
    } else{
      return {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
        offsetY: -8,
      }
    }
  }
}